











































































  import { Vue, Component } from 'vue-property-decorator';
  import { lazyInject } from '@/app/container';
  import { DashboardService, DashboardServiceSymbol } from '@/app/dashboard/dashboard-service';
  import { ChapterProgress, Dashboard } from '@/app/shared/models';
  import { setFocus } from '@/app/accessibility/accessibility-utils';
  import { setDocumentTitle } from '@/app/shared/utils/document-utils';
  import { defaultCourseImageUri } from '@/app/shared/utils/content-utils';
  import rootStoreModule from '@/app/shared/state/root';
  import UiBadgeComponent from '@/app/shared/components/ui/ui-badge-component.vue';
  import UiIconComponent from '@/app/shared/components/ui/ui-icon-component.vue';
  import UiStatusBarComponent from '@/app/shared/components/ui/ui-status-bar-component.vue';
  import UiScrollableComponent from '@/app/shared/components/ui/ui-scrollable-component.vue';
  import WrapperSimpleComponent from '@/app/shared/components/wrapper/wrapper-simple-component.vue';
  import WrapperCommonComponent from '@/app/shared/components/wrapper/wrapper-common-component.vue';
  import UiChartComponent from '@/app/shared/components/ui/ui-chart-component.vue';
  import DashboardProgressBlockComponent from '@/app/dashboard/components/dashboard-progress-block-component.vue';
  import DashboardChapterProgressComponent from '@/app/dashboard/components/dashboard-chapter-progress-component.vue';
  import BadgesDashboardComponent from '@/app/badge/ui/badges-dashboard-component.vue';
  import ExamsDashboardComponent from '@/app/exam/ui/exams-dashboard-component.vue';
  import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";
  import PreambleComponent from '@/app/preamble/components/preamble-component.vue';
  import { ExamStoreModule, ExamStoreModuleSymbol } from '@/app/exam/state';
  import { CancelToken, cancelToken, cancel, reset, restrictedThemes } from '@/app/shared/utils'
  import { CourseCompletionService, CourseCompletionServiceSymbol } from '@/app/course-completion/service';
import { has } from 'lodash';

  @Component({
    components: {
      HelpPopupComponent,
      UiChartComponent,
      UiBadgeComponent,
      UiIconComponent,
      UiStatusBarComponent,
      UiScrollableComponent,
      WrapperSimpleComponent,
      WrapperCommonComponent,
      DashboardProgressBlockComponent,
      DashboardChapterProgressComponent,
      BadgesDashboardComponent,
      ExamsDashboardComponent,
      PreambleComponent,
    }
  })
  export default class DashboardComponent extends Vue {

    public dashboard: Dashboard|null = null;

    // HACK: they are disabled now
    private showCourseProgress = false;
    private showCompetenceProgress = false;
    private showQuestionProgress = false;

    @lazyInject(DashboardServiceSymbol)
    private dashboardService: DashboardService;

    @lazyInject(ExamStoreModuleSymbol)
    private examStore: ExamStoreModule;

    @lazyInject(CourseCompletionServiceSymbol)
    private courseCompletionService: CourseCompletionService

    private queryCancelToken: CancelToken = cancelToken()

    public get courseTitle(): string|null {
      if (this.dashboard == null) {
        return null;
      }

      return this.dashboard.courseTitle;
    }




    public get formatCourseAuthorInfo(): string | null {
      if (this.dashboard == null) {
        return null
      }

      let authorInfo = ""
      let hasAuthor = false
      if(this.dashboard.authors.length > 0){
        authorInfo = authorInfo +  this.$t('dashboard.authors') + ': '
        hasAuthor = true
      } else {
        if (this.dashboard.revisionNumber != null){
          authorInfo = authorInfo + this.$t('dashboard.revision_number') + ': '
        } else {
          if (this.dashboard.revisionDate != null){
            authorInfo = authorInfo + this.$t('dashboard.revision_date') + ': '
          } else {
            return null
          }
        }
      }

      if(hasAuthor){
        let authorString = ""
        let index = 0
        this.dashboard.authors.forEach(element => {
          if(index == 0) {
            authorString = element.name
          } else {
            authorString = authorString + ", " + element.name
          }
          index++;
        });

        authorInfo = authorInfo + authorString + ' ('
      }

      if(this.dashboard.revisionDate != null){
          authorInfo = authorInfo + this.dashboard.revisionDate
      }

      if(this.dashboard.revisionDate != null && this.dashboard.revisionNumber != null){
        authorInfo = authorInfo + ' - '
      }

      if(this.dashboard.revisionNumber != null){
        authorInfo = authorInfo + this.dashboard.revisionNumber
      }

      if(hasAuthor){
        authorInfo = authorInfo + ')'
      }

      return authorInfo;
    }

    private get courseCompletionDetails() {

      const courseCompletionSettings = this.courseCompletionService.querySettings()
      if (!courseCompletionSettings) {
        return null
      }

      if (restrictedThemes(['mekh'])) {
        return null
      }

      switch (courseCompletionSettings.mode) {
        case 'final-exam':
          return this.$t('dashboard.course_completion.final_exam')
        case 'section-percentage':
          return this.$t('dashboard.course_completion.section_percentage', { percent: courseCompletionSettings.passingSectionPercentage })
        case 'none':
          return null
      }
    }

    public get coursePreamble(): string | null {
      if (this.dashboard == null || this.dashboard.preambleContent == null) return null;

      return this.dashboard.preambleContent;
    }

    public get courseSubtitle(): string|null {
      if (this.dashboard == null) {
        return null;
      }

      return this.dashboard.courseSubtitle;
    }

    public get imageStyle(): any {
      if (this.dashboard === null) {
        return {};
      }

      let courseImageUri: string|null = this.dashboard.courseImageUri;
      if (courseImageUri === null) {
        courseImageUri = defaultCourseImageUri();
      }

      return {
        background: `transparent url("${courseImageUri}") no-repeat center center`,
        backgroundSize: 'cover'
      };
    }

    public get chapterProgressItems(): ChapterProgress[] {
      if (this.dashboard == null) {
        return [];
      }

      return this.dashboard.chapterProgressItems;
    }

    public get totalReadingTime(): string|null {
      if (this.dashboard == null) {
        return null;
      }

      return this.dashboard.totalReadingTime;
    }

    public get courseTotalPercent(): number {
      if (this.dashboard === null) {
        return 0;
      }

      return this.dashboard.courseProgress.totalPercent;
    }

    public get courseRecentPercent(): number {
      if (this.dashboard === null) {
        return 0;
      }

      return this.dashboard.courseProgress.recentPercent;
    }

    public get questionsTotalPercent(): number {
      if (this.dashboard === null) {
        return 0;
      }

      return this.dashboard.questionsProgress.totalPercent;
    }

    public get questionsRecentPercent(): number {
      if (this.dashboard === null) {
        return 0;
      }

      return this.dashboard.questionsProgress.recentPercent;
    }

    public get apexConfig(): any {
      if (this.dashboard === null) {
        return {};
      }

      return {
        series: [{
          name: this.$t('dashboard.acquired_earlier').toString(),
          data: Object.values(this.dashboard.competencePercents)
        }, {
          name: this.$t('dashboard.acquired_7days').toString(),
          data: []
        }]
      };
    }

    public async mounted(): Promise<void> {
      reset(this.queryCancelToken)
      this.dashboard = await this.dashboardService.query(this.queryCancelToken);

      if (!rootStoreModule.isFirstLoad) {
        setFocus('#course-title', -1);
      }

      setDocumentTitle([
        this.$t('player.dashboard').toString()
      ]);
    }

    private destroyed() {
      cancel(this.queryCancelToken)
    }
  }
